import { useSceneEvents } from "@/components/common/scene-events-context";
import { useTypedEvent } from "@faro-lotv/app-component-toolbox";
import { IElementImg360 } from "@faro-lotv/ielement-types";
import { useCallback, useEffect } from "react";

/**
 * Handle the goToWaypoint scene event, including a waypoint sent before the scene was ready
 * (e.g. during the mode transition), which stays pending until then.
 *
 * @param goToWaypoint Moves to the waypoint, like a click on it in the current scene
 * @param isReady Whether the scene can handle the waypoint yet
 */
export function useGoToWaypointEvent(
  goToWaypoint: (waypoint: IElementImg360) => void,
  isReady = true,
): void {
  const events = useSceneEvents();
  const { pendingGoToWaypoint } = events;

  const onGoToWaypoint = useCallback(
    (waypoint: IElementImg360) => {
      pendingGoToWaypoint.waypoint = null;
      goToWaypoint(waypoint);
    },
    [goToWaypoint, pendingGoToWaypoint],
  );

  useTypedEvent(
    isReady ? events.goToWaypoint : undefined,
    isReady ? onGoToWaypoint : undefined,
  );

  useEffect(() => {
    if (isReady && pendingGoToWaypoint.waypoint) {
      onGoToWaypoint(pendingGoToWaypoint.waypoint);
    }
  }, [isReady, onGoToWaypoint, pendingGoToWaypoint]);
}
